// covered-by: frontends/carrie/src/ask-v2/home/__tests__/useAskV2ForYou.test.ts
import { useQuery } from "@tanstack/react-query";

import { getForYou } from "./forYouApi";

import { ASK_PUNTT_UNREAD_LIST_POLL_MS } from "../../utils/queries/askPuntt";

export const ASK_V2_FOR_YOU_QUERY_KEY = ["ask-v2", "for-you"] as const;

/** The home "For you" panel, polled at the sidebar's unread cadence. */
export function useAskV2ForYou() {
  return useQuery({
    queryKey: ASK_V2_FOR_YOU_QUERY_KEY,
    queryFn: getForYou,
    refetchInterval: ASK_PUNTT_UNREAD_LIST_POLL_MS,
  });
}
